import { themeStyle } from '@src/theming';

export const primaryTheme = {
  color: themeStyle.varBackgroundAlt,
  spinnerColor: themeStyle.varBackgroundAlt,
  activeColor: themeStyle.varBackgroundAlt,

  backgroundColor: themeStyle.inkMain,
  borderColor: themeStyle.inkMain,
  backgroundActiveColor: themeStyle.inkMedium,
  borderActiveColor: themeStyle.inkMedium,

  backgroundColorDark: themeStyle.darkInkMain,
  borderColorDark: themeStyle.darkInkMain,
  backgroundActiveColorDark: themeStyle.darkInkMedium,
  borderActiveColorDark: themeStyle.darkInkMedium,

  disabledColor: themeStyle.inkLightMedium,
  backgroundDisabledColor: themeStyle.inkLight,
  borderDisabledColor: themeStyle.inkLight,

  disabledColorDark: themeStyle.darkInkLightMedium,
  backgroundDisabledColorDark: themeStyle.darkInkLight,
  borderDisabledColorDark: themeStyle.darkInkLight,
};

export const primaryDarkTheme = {
  ...primaryTheme,
  color: themeStyle.darkBackgroundAlt,
  spinnerColor: themeStyle.darkBackgroundAlt,
  activeColor: themeStyle.darkBackgroundAlt,

  backgroundColor: themeStyle.darkInkMain,
  borderColor: themeStyle.darkInkMain,
  backgroundActiveColor: themeStyle.darkInkMedium,
  borderActiveColor: themeStyle.darkInkMedium,

  disabledColor: themeStyle.darkInkSuperLight,
  backgroundDisabledColor: themeStyle.darkInkLightMedium,
  borderDisabledColor: themeStyle.darkInkLightMedium,
};

export const secondaryTheme = {
  color: themeStyle.varInkMain,
  spinnerColor: themeStyle.varInkMain,
  activeColor: themeStyle.varInkMain,

  backgroundColor: themeStyle.backgroundAlt,
  borderColor: themeStyle.inkLight,
  backgroundActiveColor: themeStyle.inkSuperLight,
  borderActiveColor: themeStyle.inkLight,

  backgroundColorDark: themeStyle.darkBackgroundAlt,
  borderColorDark: themeStyle.darkInkLight,
  backgroundActiveColorDark: themeStyle.darkInkSuperLight,
  borderActiveColorDark: themeStyle.darkInkLight,

  disabledColor: themeStyle.inkLightMedium,
  backgroundDisabledColor: themeStyle.backgroundAlt,
  borderDisabledColor: themeStyle.inkLight,

  disabledColorDark: themeStyle.darkInkLightMedium,
  backgroundDisabledColorDark: themeStyle.darkBackgroundAlt,
  borderDisabledColorDark: themeStyle.darkInkLight,
};

export const ghostTheme = {
  color: themeStyle.varInkMedium,
  spinnerColor: themeStyle.varInkMedium,
  activeColor: themeStyle.varInkMain,

  backgroundColor: themeStyle.transparent,
  borderColor: themeStyle.transparent,
  backgroundActiveColor: themeStyle.inkSuperLight,
  borderActiveColor: themeStyle.inkLight,

  backgroundColorDark: themeStyle.transparent,
  borderColorDark: themeStyle.transparent,
  backgroundActiveColorDark: themeStyle.darkInkSuperLight,
  borderActiveColorDark: themeStyle.darkInkLight,

  disabledColor: themeStyle.inkLightMedium,
  backgroundDisabledColor: themeStyle.transparent,
  borderDisabledColor: themeStyle.transparent,

  disabledColorDark: themeStyle.darkInkLightMedium,
  backgroundDisabledColorDark: themeStyle.transparent,
  borderDisabledColorDark: themeStyle.transparent,
};

export const editorHeaderTheme = {
  color: themeStyle.varInkMain,
  spinnerColor: themeStyle.varInkMain,
  activeColor: themeStyle.varInkMedium,

  backgroundColor: themeStyle.backgroundAlt,
  borderColor: themeStyle.backgroundAlt,
  backgroundActiveColor: themeStyle.backgroundAlt,
  borderActiveColor: themeStyle.backgroundAlt,

  backgroundColorDark: themeStyle.darkBackgroundAlt,
  borderColorDark: themeStyle.darkBackgroundAlt,
  backgroundActiveColorDark: themeStyle.darkBackgroundAlt,
  borderActiveColorDark: themeStyle.darkBackgroundAlt,

  disabledColor: themeStyle.inkLightMedium,
  backgroundDisabledColor: themeStyle.inkSuperLight,
  borderDisabledColor: themeStyle.inkSuperLight,

  disabledColorDark: themeStyle.darkInkLightMedium,
  backgroundDisabledColorDark: themeStyle.darkInkSuperLight,
  borderDisabledColorDark: themeStyle.darkInkSuperLight,
};

export const editorMenuItemTheme = {
  backgroundActiveColor: themeStyle.varBlueLight,
};
